export default {
  unsubscribeAllCustomer: 'unsubscribe-all-customer',
  unsubscribeNetbankCustomer: 'unsubscribe-netbank-customer',
  unsubscribeLoginNetbank: 'unsubscribe-login-netbank',
};
